import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import { LEGACY_CERT_QUERY_KEY } from "@/hooks/queries/useLegacyCertStatus";
import type { UploadedCertData } from "@/hooks/queries/legacy-cert-types";

// POST /profile/legacy-cert (Story 16.3) — upload a cert as multipart FormData. On
// success, invalidate the status query so the card re-hydrates to Pending. Rides the
// reusable `apiFetch` FormData branch (Task 7) — do NOT bypass it with raw fetch, so
// the Bearer + 401-refresh handling stays intact.

export function useUploadLegacyCert() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => {
      const formData = new FormData();
      formData.append("file", file);
      return apiFetch<UploadedCertData>("/profile/legacy-cert", {
        method: "POST",
        body: formData,
      });
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [LEGACY_CERT_QUERY_KEY] });
    },
  });
}
